export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20photography%20of%20stylish%20lifestyle%20products%20arranged%20in%20organic%20circular%20composition%20on%20warm%20oatmeal%20linen%20fabric%2C%20featuring%20premium%20sneakers%2C%20folded%20knitwear%2C%20leather%20watch%2C%20sunglasses%2C%20notebook%2C%20and%20coffee%20cup%2C%20soft%20diffused%20morning%20light%20casting%20gentle%20shadows%2C%20editorial%20catalog%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20sophisticated%20product%20curation%2C%20scandinavian%20minimalism%20with%20warmth%2C%20high-end%20boutique%20atmosphere&width=1600&height=900&seq=kakobuy-hero-fresh-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty collage"
          title="Kakobuy Spreadsheet Polska - produkty i znaleziska"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/40"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-6 text-center pt-16">
        <p className="inline-block px-4 py-1.5 text-xs font-medium tracking-widest uppercase rounded-full border border-white/30 text-white/90 mb-8 backdrop-blur-sm">
          14 Kategorii Produktów
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-white leading-[1.05] tracking-tight">
          Kakobuy Spreadsheet
          <br />
          <span className="text-accent-300">Polska – Znaleziska 2026</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/80 max-w-[600px] mx-auto leading-relaxed">
          Odkrywaj tysiące produktów, porównuj popularne listy i znajdź najlepsze okazje dzięki aktualnym bazom Kakobuy Spreadsheet.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#categories"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Przeglądaj Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold border border-white/40 text-white rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {[
            'Aktualne listy produktów',
            'Szczegółowe porównania',
            'Niezależne poradniki',
            'Bezpieczne informacje',
          ].map((item) => (
            <span key={item} className="flex items-center gap-1.5 text-xs md:text-sm text-white/70">
              <i className="ri-check-line text-accent-400 text-sm"></i>
              {item}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categories" className="text-white/60 hover:text-white/90 transition-colors cursor-pointer">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}